import { render } from "./_courseStudents.vue?vue&type=template&id=468bfede"
import script from "./_courseStudents.vue?vue&type=script&lang=js"
export * from "./_courseStudents.vue?vue&type=script&lang=js"

import "./_courseStudents.vue?vue&type=style&index=0&id=468bfede&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__